module.exports = __webpack_public_path__ + "static/media/UniNeueHeavy.a7906f00.woff2";